var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile_main shadow m-l-10 bg-white b-r-10 hide"},[_c('div',{staticClass:"mobile_title shadow w-100 bg-white text-center color-black"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"df jc ac"},[_c('div',{staticClass:"mobile_box scroll",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }